import Vue from "vue";
import cashflow from "./pages/CashFlowHome.vue";
import router from "./router/router";
import store from "./store";
import VueRouter from "vue-router";
import Fragment from "vue-fragment";

//import { ErrorService } from "./services";

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Fragment.Plugin);
Vue.config.errorHandler = function (err) {
  console.log(err);
  //ErrorService.LogError(err);
};

new Vue({
  router,
  store,
  render: (h) => h(cashflow),
}).$mount("#cashflow");
